'use client';

import { useState } from 'react';
import IndustryFilter from './IndustryFilter';

interface Capability {
  title: string;
  capability: string;
  description: string;
  tags: string[];
  benefits: string[];
  icon: string;
}

interface IndustryFilterClientProps {
  capabilities: Capability[];
}

export default function IndustryFilterClient({ capabilities }: IndustryFilterClientProps) {
  const [activeTab, setActiveTab] = useState('all');

  const filteredCapabilities = activeTab === 'all' 
    ? capabilities 
    : capabilities.filter(c => c.tags.includes(activeTab));

  return (
    <>
      <IndustryFilter activeTab={activeTab} setActiveTab={setActiveTab} />
      
      <section className="py-16 lg:py-24 bg-gray-50">
        <div className="container mx-auto px-4 max-w-6xl">
          <div className="grid md:grid-cols-2 gap-12">
            {filteredCapabilities.map((cap) => (
              <div key={cap.title} className="bg-white p-8 rounded-lg shadow-sm hover:shadow-lg transition-shadow">
                <div className="text-5xl mb-4">{cap.icon}</div>
                <h3 className="text-2xl font-bold text-gray-900 mb-2">{cap.title}</h3>
                <p className="text-brand-red font-semibold text-lg mb-4">{cap.capability}</p>
                <p className="text-gray-700 mb-6 leading-relaxed">{cap.description}</p>
                <div className="space-y-2">
                  {cap.benefits.map((benefit) => (
                    <div key={benefit} className="flex items-start gap-2">
                      <span className="text-brand-red font-bold mt-1">✓</span>
                      <span className="text-gray-600">{benefit}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 lg:py-24 bg-brand-red text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl lg:text-5xl font-bold mb-6">
            Ready to Transform Your Business Communication?
          </h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            Let's discuss which capabilities matter most for your industry and goals.
          </p>
          <div className="flex justify-center">
            {/* ContactButton will be imported in parent */}
            <a href="/contact" className="inline-block bg-white text-brand-red px-8 py-4 rounded-lg font-bold hover:bg-gray-100 transition">
              Get Started Today
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
